import React from 'react';
import { BanknotesIcon } from './icons/BanknotesIcon';
import { LayersIcon } from './icons/LayersIcon';
import { ScaleIcon } from './icons/ScaleIcon';
import { ShieldIcon } from './icons/ShieldIcon';

const valueProps = [
  {
    icon: <BanknotesIcon className="w-8 h-8 text-green-500" />,
    title: 'Fair & Transparent Pricing',
    description: 'Our full-service application support is a one-time fee of $79. No hidden costs, no recurring charges. An investment for potentially thousands in savings.',
  },
  {
    icon: <LayersIcon className="w-8 h-8 text-blue-500" />,
    title: 'Comprehensive Scope',
    description: "We cover all major federal programs: PSLF, IDR/SAVE, TPD, and more. Our system finds every opportunity so you don't miss a thing.",
  },
  {
    icon: <ScaleIcon className="w-8 h-8 text-blue-600" />,
    title: 'The Smarter Legal Alternative',
    description: 'Get expert-level application preparation and support without the hefty legal fees. We provide the same accuracy at a fraction of the cost.',
  },
  {
    icon: <ShieldIcon className="w-8 h-8 text-green-600" />,
    title: 'Expert-Built & Secure',
    description: 'Designed by a Wall Street tech veteran, our platform uses bank-level encryption to keep your data safe and your application process compliant.',
  },
];

const ValuePropCard: React.FC<{ item: typeof valueProps[0] }> = ({ item }) => (
  <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 flex flex-col items-start text-left h-full">
    <div className="bg-gray-100 p-3 rounded-xl mb-6">
      {item.icon}
    </div>
    <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
    <p className="text-gray-600">{item.description}</p>
  </div>
);

const AnalyticsDashboard: React.FC = () => {
  return (
    <section className="py-16 sm:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight text-gray-900">
            The ForgivePath Advantage
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-lg md:text-xl text-gray-600">
            We combine Wall Street-grade technology with a client-first mission. Here's why our approach is better.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {valueProps.map((item) => (
            <ValuePropCard key={item.title} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default AnalyticsDashboard;